"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var clientinfo_service_1 = require('../../clientinfo.service');
var http_1 = require('@angular/http');
var core_2 = require('angular2-cookie/core');
var router_deprecated_1 = require('@angular/router-deprecated');
var SuccessComponent = (function () {
    function SuccessComponent(clientInfo, http, _cookieService, router) {
        this.clientInfo = clientInfo;
        this.http = http;
        this._cookieService = _cookieService;
        this.router = router;
    }
    SuccessComponent.prototype.ngOnInit = function () {
    };
    SuccessComponent.prototype.openNewTab = function () {
        // if(this.clientInfo.service['tariff'] == 1) {
        // 	var url = this.clientInfo.service["redirect_url"];
        // 	if(url != null && url != '') {
        // 		window.location.href = 'http://'+url;
        // 	}
        // 	else {
        // 		this.router.navigate(['Advert']);
        // 	}
        // }
        // else {
        // 	window.location.href = "about:blank";
        // }
        // редиректим заданых клиентов на заданные урлы
        var redirectUrl = this.clientInfo.service['promo_url'];
        if (redirectUrl) {
            if (window.location) {
                window.location.href = redirectUrl;
            }
            location.href = redirectUrl;
        }
        else {
            this.router.navigate(['Advert', { 'auth': true }]);
        }
    };
    SuccessComponent = __decorate([
        core_1.Component({
            selector: 'smartwifi-success',
            // templateUrl: './app/steps/success/success.template.html',
            template: require('./success.template.html'),
            providers: [core_2.CookieService]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof clientinfo_service_1.ClientInfoService !== 'undefined' && clientinfo_service_1.ClientInfoService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object, (typeof (_c = typeof core_2.CookieService !== 'undefined' && core_2.CookieService) === 'function' && _c) || Object, (typeof (_d = typeof router_deprecated_1.Router !== 'undefined' && router_deprecated_1.Router) === 'function' && _d) || Object])
    ], SuccessComponent);
    return SuccessComponent;
    var _a, _b, _c, _d;
}());
exports.SuccessComponent = SuccessComponent;



/*****************
 ** WEBPACK FOOTER
 ** ./app/steps/success/success.component.ts
 ** module id = 993
 ** module chunks = 1
 **/